import { render, staticRenderFns } from "./CoPlanSelectUpgrades.vue?vue&type=template&id=c5bc4086&scoped=true&"
import script from "./CoPlanSelectUpgrades.vue?vue&type=script&lang=ts&"
export * from "./CoPlanSelectUpgrades.vue?vue&type=script&lang=ts&"
import style0 from "./CoPlanSelectUpgrades.vue?vue&type=style&index=0&id=c5bc4086&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bc4086",
  null
  
)

export default component.exports